import { MdAccessTimeFilled } from "react-icons/md";
import dynamic from "next/dynamic";
import axiosRequest from "@/utils/axios-utils";
// import { handleGettingStoreLocatorsApiRouteSWR } from "@/services/store/getLocations";
import MainLoader from "@/components/Reusable/Loaders/MainLoader";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import SEO from "@/components/seo";
import { handshakeCookieName } from "@/constants";
import { localeHandShake } from "@/services/token/handshake";

import Select, { components } from "react-select";
import { HiLocationMarker } from "react-icons/hi";
import Image from "next/image";
import useClient from "@/hooks/global/useClient";
import { customStyles } from "@/constants/branches";
import { IoMdArrowDropdown } from "react-icons/io";
import useCitySearch from "@/hooks/branches/useCitySearch";
const Map = dynamic(() => import("@/components/Store/Map"), { ssr: false });

const seoData = {
  title_ar: " فروع المنيع في السعودية",
  title_en: "Almanea Branches in Saudi Arabia",
  description_ar:
    "استخدم اداة البحث وخريطة الفروع لعرض أقرب فرع لموقعك والحصول على الاتجاهات إليه.",
  description_en:
    "Use the search tool and branch map to view the nearest branch to your location and get directions to it.",
};
function Index({ locatorsData }) {
  const [searchOptions, setSearchOptions] = useState([]);

  const { t } = useTranslation("common");
  const { locale } = useRouter();
  const [currentLocation, setcurrentLocation] = useState({
    id: null,
    name: "",
    location: [0, 0],
    empty: true,
  });

  const { isClient } = useClient();

  const { citiesOptions, regionsOptions, filteredLocatorsData } = useCitySearch(
    {
      regionId: searchOptions.regionId,
      cityId: searchOptions.cityId,
      locatorsData,
    }
  );

  useEffect(() => {
    if (filteredLocatorsData) {
      if (filteredLocatorsData.length) {
        let newObjOfDefaultLocation = {
          id: filteredLocatorsData[0]?.id,
          name: filteredLocatorsData[0]?.name,
          location: [
            filteredLocatorsData[0]?.lat,
            filteredLocatorsData[0]?.lng,
          ],
          empty: false,
        };
        setcurrentLocation(newObjOfDefaultLocation);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredLocatorsData]);

  // Handle click on Location

  const mapRef = useRef(null);

  const handleChangeLocation = (newlat, newlang, newName, id) => {
    let newObjOfNewLocation = {
      id: id,
      name: newName,
      location: [newlat, newlang],
      empty: false,
    };
    setcurrentLocation(newObjOfNewLocation);
  };

  return (
    <>
      <SEO
        title={seoData?.[`title_${locale}`]}
        description={seoData?.[`description_${locale}`]}
      />
      <section className="mx-auto my-5  w-[80%] max-[570px]:w-[93%] ">
        <h1 className="mb-5 text-[14px] md:text-[16px] font-semibold md:font-medium text-[#9CA3AF]">
          {t("OurBranches")}
        </h1>
        {filteredLocatorsData ? (
          <div className="grid grid-cols-12 md:gap-[33px] justify-center mx-auto w-full ">
            <div className="col-span-4 max-[991px]:col-span-6 max-[570px]:col-span-12 max-[570px]:order-1">
              {/* search for branches */}
              <div className="mb-[11px] rounded-[12px]  shadow-md border border-[#EDEDED] px-[16.5px] py-[12px] md:p-[20px]">
                <p className="text-[#0C0A09] mb-[10px] font-bold text-[15px] md:text-[18px] ">
                  {t("findOurBranches")}
                </p>
                <div className="flex flex-col">
                  <label
                    htmlFor="city_id"
                    className="text-[10px] mb-1 md:text-[12px] text-[#767B83]  cursor-pointer"
                  >
                    {t("cityInput")}
                  </label>
                  <div className="pb-4">
                    <Select
                      id="city_id"
                      placeholder={locale == "ar" ? "اختر من هنا" : "Select"}
                      isClearable
                      isSearchable
                      components={{ DropdownIndicator }}
                      styles={customStyles}
                      menuPortalTarget={isClient ? document?.body : null}
                      options={regionsOptions}
                      onChange={(e) => {
                        setSearchOptions({
                          regionId: e?.value,
                          cityId: null,
                        });
                      }}
                      name="city_id"
                      className="w-full bg-white border rounded-[8px] outline-0"
                    />
                  </div>
                </div>

                <div className="flex flex-col ">
                  <label
                    htmlFor="cityId"
                    className=" mb-1 text-[10px] md:text-[12px] text-[#767B83]  cursor-pointer"
                  >
                    {t("regionInput")}
                  </label>
                  <div className="pb-4">
                    <Select
                      id="cityId"
                      placeholder={locale == "ar" ? "اختر من هنا" : "Select"}
                      isClearable
                      isSearchable
                      value={
                        searchOptions.cityId
                          ? {
                              label: searchOptions.cityId,
                              value: searchOptions.cityId,
                            }
                          : null
                      }
                      components={{ DropdownIndicator }}
                      styles={customStyles}
                      menuPortalTarget={isClient ? document?.body : null}
                      options={citiesOptions}
                      onChange={(e) => {
                        setSearchOptions({
                          ...searchOptions,
                          cityId: e?.value,
                        });
                      }}
                      name="region_id"
                      className="w-full bg-white border rounded-[8px] outline-0"
                    />
                  </div>
                </div>
              </div>

              <div className="col-span-8 max-[991px]:col-span-6 max-[570px]:col-span-12 max-[570px]:order-2 mb-[15px]  sm:hidden block ">
                <Map
                  currentLocation={currentLocation}
                  data={filteredLocatorsData}
                  handleChangeLocation={handleChangeLocation}
                  mapRef={mapRef}
                />
              </div>

              {/* our branches */}
              <ul className="max-h-[75vh] overflow-y-auto  shadow-md border border-[#EDEDED] px-[16.5px] py-[12px] md:p-[20px]  scrollbar-custom-1 rounded-[12px]">
                {filteredLocatorsData?.map((item, i) => (
                  <li
                    key={i}
                    onClick={() => {
                      // e.stopPropagation();
                      handleChangeLocation(
                        item.lat,
                        item.lng,
                        item.name,
                        item.id
                      );
                    }}
                    className={`item   ${
                      i === filteredLocatorsData?.length - 1
                        ? ""
                        : "border-b border-b-[#ddd]"
                    } py-[12px] md:py-[12px] 
                   duration-200
                   ${currentLocation.id == item.id ? "" : " "}
                  `}
                  >
                    <div
                      className={`hover:bg-[#e5e9f5]  ${
                        currentLocation.id == item.id
                          ? "bg-[#e5e9f5] text-[#00269A]"
                          : ""
                      } transition-all duration-300 group cursor-pointer hover:text-[#00269A] py-[9px] px-[12px] rounded-[10px]`}
                    >
                      <h3
                        className={`font-semibold text-[14px] md:text-[16px] mb-[10px] `}
                      >
                        {item.name}
                      </h3>
                      <div className="flex items-center  gap-[6px]  text-[12px] md:text-[14px]">
                        <HiLocationMarker
                          size="20px"
                          className={`self-start flex-shrink-0 `}
                        />
                        <p className={` `}>{item.address}</p>
                      </div>

                      <div
                        className={`items-end justify-between  ${
                          currentLocation.id == item.id ? "flex" : "hidden"
                        }  mt-1 transition-all duration-300 group-hover:flex `}
                      >
                        {item.normal_day_open_time && (
                          <div className="flex items-center  gap-[6px]  text-[12px] md:text-[14px]">
                            <MdAccessTimeFilled
                              size="20px"
                              className={`self-start flex-shrink-0`}
                            />
                            <p className={` `}>
                              {t("workingTimes")} {item.normal_day_open_time}{" "}
                              {item.friday_open_time}
                            </p>
                          </div>
                        )}

                        {((item?.lat && item?.lng) || item?.website) && (
                          <a
                            href={
                              item?.website
                                ? item?.website
                                : `https://www.google.com/maps?q=${item?.lat},${item?.lng}`
                            }
                            target="_blank"
                            className={`bg-[#00269A] campaign:bg-campaignAccent ${
                              currentLocation.id == item.id ? "flex" : "hidden"
                            }  group-hover:flex ms-auto h-[28px] md:[31px] px-3  items-center justify-center gap-[5px] rounded-md text-white text-[12px] md:text-[14px]`}
                          >
                            {t("Show")}
                            <Image
                              src="/imgs/googlemarker.png"
                              alt="marker"
                              width={20}
                              height={20}
                              className="w-[10px] h-[15px] md:w-[13px] md:h-[18px]"
                            />
                          </a>
                        )}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-span-8 max-[991px]:col-span-6 max-[570px]:col-span-12 max-[570px]:order-2 hidden sm:block ">
              <Map
                currentLocation={currentLocation}
                data={filteredLocatorsData}
                handleChangeLocation={handleChangeLocation}
                mapRef={mapRef}
              />
            </div>
          </div>
        ) : (
          <div className="w-[100%] h-[60vh] flex justify-center items-center">
            <MainLoader spinnerColor="red" />
          </div>
        )}
      </section>
    </>
  );
}

export default Index;

export async function getServerSideProps(ctx) {
  const { locale, req, res } = ctx;
  const handshake =
    req.cookies[handshakeCookieName(locale)] ||
    (await localeHandShake(locale, { req, res }))?.data?.token;

  // let fetchedDataPure = await handleGetCurraddressesSWR([
  //   mage,
  //   handshake.data.token,
  // ]);

  // Get Store Locators

  let config = {
    method: "get",
    url: `mstore/store-locator`,
    headers: {
      Authorization: `Bearer ${handshake}`,
      admin: `Bearer ${process.env.MW_ADMIN_TOKEN}`,
    },
  };

  let fetchStoreLocators = await axiosRequest.request(config);

  return {
    props: {
      locatorsData: fetchStoreLocators.data.data,
      ...(await serverSideTranslations(locale, ["common", "store"])),
    },
  };
}

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <IoMdArrowDropdown color="#767B83" size={"20"} />
    </components.DropdownIndicator>
  );
};
